var map = {
	"./adv.vue": 2351,
	"./assetstokens.vue": 5067,
	"./cipherrank.vue": 9478,
	"./giftorder.vue": 8036,
	"./gifts.vue": 3446,
	"./index.vue": 8880,
	"./login.vue": 3937,
	"./luckylottery.vue": 1930,
	"./luckylotteryitems.vue": 5093,
	"./luckylotterylogs.vue": 7321,
	"./minecate.vue": 4290,
	"./minelucky.vue": 9744,
	"./minetask.vue": 6723,
	"./pushtask.vue": 3312,
	"./rankactivity.vue": 625,
	"./rankactivityitems.vue": 3165,
	"./rankactivitylogs.vue": 3325,
	"./rechargelist.vue": 1135,
	"./ref.vue": 6111,
	"./stat.vue": 6934,
	"./task.vue": 5707,
	"./uref.vue": 7431,
	"./userassetsstat.vue": 5885,
	"./userlist.vue": 2406,
	"./validatortask.vue": 4031
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5535;